import { PaymentGatewayEnum } from "@app/core/enums/payment/payment-gateway.enum";
import { RazorpayPaymentHandler } from "../payment/razorpay-payment-handler";
import { JuspayPaymentHandler } from "../payment/juspay-payment-handler";
import { IndustryBuyingPaymentHandler } from "../payment/industrybuying-payment-handler";

export const PaymentGatewayMapper: Map<PaymentGatewayEnum, any> = new Map();
PaymentGatewayMapper.set(PaymentGatewayEnum.RAZORPAY, RazorpayPaymentHandler);
PaymentGatewayMapper.set(PaymentGatewayEnum.JUSPAY, JuspayPaymentHandler);
PaymentGatewayMapper.set(PaymentGatewayEnum.INDUSTRYBUYING,IndustryBuyingPaymentHandler);
